<template>
  <div>
    <options-light-list :options="userOptions"></options-light-list>
  </div>
</template>

<script>
import { DefaultValues, User } from '@/mixins'

export default {
  name: 'UserOptionsList',
  components: {
    OptionsLightList: () => import('@/components/options/OptionsLightList')
  },
  mixins: [DefaultValues, User],
  props: {
    sourceUser: {
      type: Object
    },
    propsTab: String
  }
}
</script>
